<template>
  <base-setting-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners">
    <div class="">
      <div class="flex a-center">
        <div class="flex a-center">组件标题:
          <div>
            <Input class="m-l-10" placeholder="组件标题" v-model="iteminfo.config.menutitle"/>
          </div>
        </div>
        <div class="block">
          <!--          <div class="flex a-center">-->
          <!--            <div class="border p-l-5" style="width: 80px;height: 30px;line-height: 30px">-->
          <!--              {{ iteminfo.config.titleColor }}-->
          <!--            </div>-->
          <!--            <div class="block">-->
          <!--              <ColorPicker class="m-l-10 ld-color-pick" recommend-->
          <!--                           v-model="iteminfo.config.titleColor"/>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div class=" m-t-10 flex a-center">
        <div class="m-r-10">标题颜色:</div>
        <div class="flex a-center">
          <div class="border p-l-5" style="width: 80px;height: 30px;line-height: 30px">
            {{ iteminfo.config.titleColor }}
          </div>
          <ColorPicker class="m-l-10 ld-color-pick" recommend
                       v-model="iteminfo.config.titleColor"/>
        </div>
      </div>
      <div class=" m-t-10 flex a-center">
        <div class="">呈现样式：</div>
        <RadioGroup class="" v-model="iteminfo.config.displayType">
          <radio :label="1" size="small" style="">
            <span class="fs-13">缩进</span>
          </radio>
          <radio :label="2" size="small" style="margin-left: 30px">
            <span class="fs-13">标准</span>
          </radio>
        </RadioGroup>
      </div>
      <div class="flex a-center m-t-10">
        显示模式：
        <RadioGroup v-model="iteminfo.config.haslimit">
          <Radio :label="1" class="fs-13" size="small">
            有限
          </Radio>
          <Radio :label="0" class="m-l-30 fs-13" size="small">
            无限
          </Radio>
        </RadioGroup>
      </div>
      <div class="flex a-center m-t-10" v-if="iteminfo.config.haslimit === 1">
        显示个数：
        <input-number :min="1" style="width: 180px" v-model="iteminfo.config.showNum"></input-number>
      </div>
      <div class="m-t-10">链接:</div>
      <div class="m-t-10">
        <tooltip :disabled="!iteminfo.config.jumpObj.linkUrl"
                 max-width="300"
                 style="width: 100%">
          <Input clearable
                 id="input-product" placeholder="加载链接地址"
                 readonly v-model="iteminfo.config.jumpObj.linkUrl">
          <span
            @click="showMaterialModal()"
            class="icon-link" slot="append" style="cursor: pointer"
          ></span>
          </Input>

          <div slot="content" style="white-space: normal;">
            {{ iteminfo.config.jumpObj.linkUrl }}
          </div>
        </tooltip>
      </div>

    </div>

    <material-choice-widget
      :on-ok="materialChoiceOk"
      :pages="choosePage()"
      ref="materialChoiceWidget"
      title="选择链接"/>
  </base-setting-widget>
</template>

<script>
import BaseSettingWidget from '../base/BaseSettingWidget'
import RatioDiv from '../../common/RatioDiv'
import MaterialChoiceWidget from '@/components/common/chiose/MaterialChoiceWidget'
import {parseUrl} from '@/utils/UrlFormat'
import {getPages} from '@/components/common/chiose/MaterailChoiceWidgetUtil'

export default {
  name: 'DynamicSettingWidget',
  components: {RatioDiv, BaseSettingWidget, MaterialChoiceWidget},
  props: {
    iteminfo: Object
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      console.log('produtSettingWidget init')
    },
    choosePage () {
      return getPages([5])
    },
    showMaterialModal () {
      this.$refs.materialChoiceWidget.show()
    },
    materialChoiceOk (data) {
      if (data && data.length > 0) {
        this.iteminfo.config.jumpObj.linkUrl = data[0].url
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .lin2 {
    color: #333;
    font-size: 13px;
    line-height: 20px;
    height: 40px;
    margin-top: 6px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 2; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }

  .modal-product-link ::v-deep {
    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }

  //扩大商品链接按钮点击范围
  .icon-link {
    padding: 7px;
    margin: 0;
  }

  //扩大商品链接按钮点击范围
  #input-product ::v-deep {
    .ivu-input-group-append {
      padding: 0;
    }
  }

</style>
